import PolluterCard from './PolluterCard';
import TripInfoCard from './TripInfoCard';
import ComparisonCarousel from './ComparisonCarousel';

export default class State {
  static cards = {
    polluterCard: null,
    tripInfoCard: null,
    comparisonCarousel: null
  }

  static addPolluter(polluter) {
    State.cards.polluterCard = new PolluterCard(polluter);
    State.cards.polluterCard.insert();
  }

  static removePolluter() {
    if (State.cards.polluterCard) {
      State.cards.polluterCard.destroy();
      State.cards.polluterCard = null;
    }
  }

  static changePolluter(polluter) {
    State.removePolluter();
    State.addPolluter(polluter);
  }

  static addComparison(polluter, tripIdx) {
    State.cards.comparisonCarousel = new ComparisonCarousel(polluter, tripIdx);
    State.cards.comparisonCarousel.insert();
  }

  static removeComparison() {
    if (State.cards.comparisonCarousel) {
      State.cards.comparisonCarousel.destroy();
      State.cards.comparisonCarousel = null;
    }
  }

  static changeComparison(polluter, tripIdx) {
    State.removeComparison();
    State.addComparison(polluter, tripIdx);
    State.changeTripInfo(polluter.trips[tripIdx]);
  }

  static addTripInfo(trip) {
    State.cards.tripInfoCard = new TripInfoCard(trip);
    State.cards.tripInfoCard.insert();
  }

  static removeTripInfo() {
    if (State.cards.tripInfoCard) {
      State.cards.tripInfoCard.destroy();
      State.cards.tripInfoCard = null;
    }
  }

  static changeTripInfo(trip) {
    State.removeTripInfo();
    State.addTripInfo(trip);
  }
};
